module.exports = __webpack_public_path__ + "img/avatar.1615f604.svg";